<template>
    <b-form-row>
        <b-col cols="6">
            <b-form-group
                id="Group-TaskValue"
                :label="value_name || 'Value'"
                label-for="TaskValue"
            >
                <b-form-select
                    v-if="!!is_selection_value_type"
                    id="TaskValue"
                    v-model="itemModel.task_value"
                    :options="value_selections"
                    :disabled="disabled"
                >
                    <template #first>
                        <b-form-select-option :value="null" disabled>
                            Select Value
                        </b-form-select-option>
                    </template>
                </b-form-select>
                <b-form-input
                    v-else
                    id="TaskValue"
                    name="TaskValue"
                    size="sm"
                    placeholder="Enter Value"
                    type="number"
                    :min="value_min || 0"
                    :max="value_max || 1000"
                    step="any"
                    v-model="itemModel.task_value"
                    :readonly="disabled"
                />
            </b-form-group>
        </b-col>
        <b-col cols="6" class="mt-4 pt-2">
            <b-form-checkbox
                id="taskChecked"
                v-model="itemModel.task_checked"
                name="taskChecked"
                :value="1"
                :unchecked-value="0"
                :disabled="disabled"
            >
                Completed
            </b-form-checkbox>
        </b-col>
        <b-col cols="12" class="mb-2">
            <b-form-group
                id="Group-TaskNotes"
                label="Notes:"
                label-for="TaskNotes"
            >
                <b-form-textarea
                    id="TaskNotes"
                    name="TaskNotes"
                    size="sm"
                    placeholder="Enter Notes"
                    v-model="itemModel.task_notes"
                    :readonly="disabled"
                />
            </b-form-group>
        </b-col>
    </b-form-row>
</template>
<script>
export default {
    name: 'orders-ViewTask',

    props: ['value', 'masterItem', 'disabled'],

    computed: {
        value_name() {
            console.log('masterItem', this.masterItem)
            return this.masterItem && this.masterItem.value_name
        },
        value_selections() {
            try {
                const _selections = JSON.parse(
                    this.masterItem && this.masterItem.value_selections
                )
                if (!Array.isArray(_selections)) throw new Error('Not Array')
                return _selections
            } catch (err) {
                return []
            }
        },
        value_max() {
            return (this.masterItem && this.masterItem.value_max) || 1000
        },
        value_min() {
            return (this.masterItem && this.masterItem.value_min) || 0
        },
        default_value() {
            return (this.masterItem && this.masterItem.default_value) || null
        },
        is_selection_value_type() {
            return !!(
                this.masterItem && this.masterItem.is_selection_value_type
            )
        },
        itemModel: {
            get() {
                return this.value
            },

            set(_value) {
                this.$emit('input', _value)
            },
        },
    },
}
</script>
